export default {
  page_title: 'SolvV',
  hello: 'Hello!',
  delete: 'Delete',
  edit: 'Edit',
  search: 'Search',
  confirm: 'Confirm',
  cancel: 'Cancel',
  type: 'type',
  next: 'Next',
  batch_upload: 'Batch Upload',
  save_as_draft: 'Save as Draft',
  basic_information: 'Basic Information',
  additional_information: 'Additional Information',
  dignose: 'Diagnose',
  knowledge_base: 'Knowledge Base',
  tag: 'Tag',
  analyse: 'Analyse',
  template: 'Template',
  flow: 'Flow (Coming soon)',
  machine: 'Machine',
  issues: 'Issues',
  causes: 'Causes',
  routines: 'Routines',
  menu_diagnose: 'Diagnose',
  menu_knowledge_base: 'Knowledge Base',
  menu_insights: 'Insights',
  dashboard_welcome: 'What do you want to solve today?',
  dashboard_dignose: 'Diagnose an Issue',
  dashboard_knowledge_base: 'Knowledge Base',
  dashboard_analyse: 'Insights',
  knowledge_base_suggestion_view: 'User Suggestions Review',
  template_add_new: 'Add New Template',
  template_existing: 'Existing Templates',
  flow_add_new: 'Add New Flow',
  flow_existing: 'Existing Flows',
  machine_add_new: 'Add New Machine',
  machine_existing: 'Existing Machines',
  machine_all_machines: 'All Machines',
  machine_name: 'Machine Name',
  alias: 'Alias',
  location: 'Location',
  service_number: 'Service Number',
  unique_id: 'Unique ID',
  machine_type: 'Machine Type',
  manufacturer: 'Manufacturer',
  serial_number: 'Serial Number',
  construction_date: 'Construction Date',
  acceptance_date: 'Acceptance Date',
  template_information: 'Template Information',
  template_type: 'Template Type',
  template_name: 'Template Name',
  save: 'Save',
  yes: 'Yes',
  no: 'No',
  enter: 'Enter',
  input: 'Input',
  select: 'Select',
  email: 'Email',
  password: 'Password',
  current_password: 'Current Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  initial_password: 'Initial Password',
  change_password: 'Change Password',
  log_out: 'Log Out',
  user_management: 'User Management',
  client_management: 'Client Management',
  first_name: 'First Name',
  last_name: 'Last Name',
  full_name: 'Full Name',
  role: 'Role',
  company: 'Company',
  company_name: 'Company Name',
  address: 'Address',
  contact: 'Contact',
  description: 'Description',
  status: 'Status',
  action: 'Action',
  active: 'Active',
  deactivated: 'Deactivated',
  add_new_user: 'Add New User',
  edit_user: 'Edit User "{{name}}"',
  add_new_client: 'Add New Client',
  edit_client: 'Edit Client "{{name}}"',
  license_status: 'License Status',
  preview: 'Preview',
  resource_library: 'Resource Library',
  files: 'Files',
  image_gallery: 'Image Gallery',
  machine_images: 'Machine Images',
  issue_images: 'Issue Images',
  cause_images: 'Cause Images',
  no_images: 'No images',
  copy_link: 'Copy Link',
  link_causes: 'Link Cause(s)',
  link_machines: 'Link Machine(s)',
  search_for_machine: 'Search for Machine',
  search_for_issue: 'Search for issue',
  no_machines: 'No Machines',
  no_issues: 'No Issues',
  no_possible_causes: 'No possible causes',
  possible_causes: 'Possible Causes',
  identified_causes: 'Identified Causes',
  no_description: 'No description.',
  details: 'Details',
  solution_grid: 'Solution Grid',
  issue: 'Issue',
  cause: 'Cause',
  routine: 'Routine',
  heatmap: 'Heatmap',
  notifications: 'Notifications',
  issues_to_be_reviewed: 'Issues (To be Reviewed)',
  causes_to_be_reviewed: 'Causes (To be Reviewed)',
  routines_to_be_reviewed: 'Routine (To be Reviewed)',
  show_more: 'Show more',
  show_less: 'Show less',
  delete_failed: 'Delete failed!',
  submit_failed: 'Submit failed!',
  submit_failed_try_again: 'Submit failed, please try again!',
  load_images_failed: 'Load Images Failed!',
  upload_failed: 'Upload Failed!',
  upload_image_type_error: 'You can only upload JPG/PNG/BMP file!',
  upload_image_size_error: 'Image must smaller than 2MB!',
  password_mismatch: 'Passwords do not match!',
  password_changed: 'Password changed successfully!',
  login_failed: 'Login failed, Please try again.',
  enter_email: 'Enter Email address',
  enter_password: 'Enter password',
  enter_new_password: 'Enter new password',
  enter_current_password: 'Enter current password',
  enter_routine_name: 'Input Routine Name',
  enter_routine_description: 'Enter routine description...',
  select_date: 'Select Date',
  required_email: 'Please input Email address!',
  required_password: 'Please input password!',
  required_current_password: 'Please input current password!',
  required_confirm_password: 'Please confirm password!',
  required_first_name: 'Please input first name!',
  required_last_name: 'Please input last name!',
  required_role: 'Please select role!',
  required_company: 'Please select Company!',
  required_status: 'Please select Status!',
  required_machine_name: 'Please input Machine name!',
  required_cause_name: 'Please input cause name!',
  required_issue_name: 'Please input issue name!',
  required_routine_name: 'Please input routine name!',
  required_description: 'Please input description!',
  machine_created: 'Machine Created Successfully!',
  machine_updated: 'Machine Updated Successfully!',
  routine_created: 'New Routine Created!',
  routine_updated: 'Routine Updated!',
  suggestion_submitted: 'Suggestion Submitted',
  deleting: 'Deleting...',
  suggest_routine: 'Suggest a Routine',
  diagnose_issue: 'Diagnose an Issue',
  flow_coming_soon: 'Flow (Coming soon)',
  diagnose_coming_soon: 'Diagnose (Coming soon)',
  people_coming_soon: 'People (Coming soon)',
  skillset_coming_soon: 'Skillset (Coming soon)',
  diagnosis_insight_coming_soon: 'Diagnosis Insight (Coming soon)',
  people_reserve_coming_soon: 'People Reserve (Coming soon)',
  skillset_reserve_coming_soon: 'Skillset Reserve (Coming soon)',
  welcome_to_solvv: 'Welcome to SolvV',
  remember_me: 'Remember me',
  sign_in: 'Sign In',
  required_company_name: 'Please input company name!',
  required_company_type: 'Please select company type!',
  required_email_lowercase: 'Please input email!',
  complete_form: 'Please complete the form correctly.',
  submit_failed_short: 'Submit failed.',
  fill_user_information: 'Please fill user information to continue.',
  fill_company_information: 'Please fill company information to continue.',
  select_company: 'Select Company',
  images_uploading:
    'Image(s) upload in progress, please submit when it completed!',
  routine_name: 'Routine Name',
  operation_and_safety_precautions: 'Operation And Safety Precautions',
  need_assistance: 'Need assistance',
  call_machine_builder: 'Call Machine Builder',
  create_ticket: 'Create a Ticket',
  delete_machine: 'Delete {{name}}',
  confirm_delete_machine: 'Are you sure to delete {{name}}?',
  copy: 'Copy',
  template_copied: 'Template Copy Successfully!',
  go_to_copied_template: 'Go to copied template?',
  stay_here: 'Stay Here',
  copy_failed: 'Copy Failed!',
  delete_failed_capitalized: 'Delete Failed!',
  delete_template: 'Delete {{name}}',
  confirm_delete_template: 'Are you sure to delete {{name}}?',
  back: 'Back',
  select_safety_instructions: 'Select Safety Instructions',
  unlink_cause_confirmation: 'Are you sure you want to unlink this cause?',
  remove_step_confirmation: 'Are you sure you want to remove this step?',
  add_new_step: 'Add New Step',
  image: 'Image',
  name: 'Name',
  enter_step_description: 'Enter step description...',
  select_frequency: 'Select Frequency',
  download_company_logs: 'Download Company Logs',
  select_a_company: 'Select a company',
  log_file: 'Log File',
  select_a_log_file: 'Select a log file',
  no_permission: "Sorry, you don't have permission to this page!",
  password_reset_success: 'Password reset successfully!',
  reset_password_login_again:
    'User information is missing. Please login again.',
  previous: 'Prev',
  language: 'Language',
  english: 'English',
  german: 'German',
  next_issue: 'Next',
  no_matching_issue:
    'Sorry, there is no matching issue based on the photo you uploaded.',
  edit_versions: 'Edit Versions',
  version_info: 'Version Info',
  version_name: 'Version Name',
  input_version_name: 'Please input version name',
  input_description: 'Please input description',
  unsaved_changes: 'Wait! You have unsaved changes',
  leave_anyway: 'Leave anyway',
  routine_repair_exit: "You're going to leave the routine repair flow.",
  search_for: 'Search for {{value}}',
  submitted_by: 'Submitted By:',
  at: 'at',
  approved_reason: 'Approved Reason',
  rejected_reason: 'Rejected Reason',
  reject: 'Reject',
  accept_and_save: 'Accept and Save',
  production: 'Production',
  trial: 'Trial',
  coming_soon: 'Coming soon!',
  go_back: 'Go Back',
  upload: 'Upload',
  file_upload_success: 'File {{action}} Successfully!',
  file_upload_failed: 'File {{action}} Failed!',
  could_not_preview_image: 'Could not preview this image.',
  no_preview_available: 'No preview available for this file.',
  delete_file_confirmation: 'Are you sure you want to delete {{name}}',
  suggest_an_issue: 'Suggest an Issue',
  suggest_a_cause: 'Suggest a Cause',
  suggest_a_routine: 'Suggest a Routine',
  suggested_issue: 'Suggested Issue',
  suggested_cause: 'Suggested Cause',
  suggested_routine: 'Suggested Routine',
  qualification: 'Qualification',
  labels: 'Labels',
  tools: 'Tools',
  link_cause_hint: 'Select the cause(s) you would like to link to this routine',
  click_to_upload_image: 'Click to Upload Image',
  identify_cause_hint:
    'Issue Hard to describe? Try below process to identify causes:',
  diagnose_done_message: 'Done! Check out the result on the right!',
  repair_routine: 'Repair Routine',
  routine_completed: 'Routine Completed.',
  duration: 'Duration',
  is_issue_resolved: 'Is the issue resolved?',
  no_back_to_diagnosis: 'No, Back To Diagnosis',
  no_need_help: 'No, I Need More Help',
  link_machine: 'Link Machines',
  select_machine_hint:
    'Select the machine(s) you would like to link to this template *',
  current_label: 'Current ({{count}})',
  to_be_reviewed_label: 'To-Be-Reviewed ({{count}})',
  rejected_label: 'Rejected ({{count}})',
  linked_in_solution_grid: 'Linked in Solution Grid',
  add_new_cause: 'Add New Cause',
  add_new_routine: 'Add New Routine',
  add_new_issue: 'Add New Issue',
  add_issue: 'Add Issue',
  save_as_new_version: 'Save as New Version',
  remove: 'Remove',
  find_other_solution: ' Find other solution?',
  observe_other_issue: 'Observe other Issue?',
  compare_reason: 'Compare reason for searched image:',
  description_for_issues_image: "Description for issues' images:",
  selected: 'Selected',
  matched: 'Matched',
  not_right_cause: 'Not the right cause',
  close_without_cause: 'Close without cause',
  found_the_right_cause: 'Found the right cause',
  yes_go_to_routine: 'Yes, go to routine',
};
